module.exports = __webpack_public_path__ + "img/adp.219ef7d2.svg";